import Cookies from "js-cookie";
// According to the GDPR’s definition of persistent cookies, set for 12 months
var COOKIE_EXPIRES_IN_DAYS = 365;
export var toggleCookie = function(key, value) {
    if (value) {
        setCookies(key, value);
    } else {
        removeCookie(key);
    }
};
export var setCookies = function(key, value) {
    Cookies.set(key, value, {
        expires: COOKIE_EXPIRES_IN_DAYS
    });
};
export var getCookies = function(key) {
    return Cookies.get(key);
};
export var removeCookie = function(key) {
    return Cookies.remove(key);
};
